export async function fetchData(url) {
    const response = await fetch(url, { method: 'get', credentials: 'same-origin' });
    const data = await response.json();
    
    if (response.ok) {
        return data;
    } else {
        console.log(`Status ${status} response`);
    }
}